export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar-header/index.ts